import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {Select, Store} from "@ngxs/store";
import {ToggleAppTheme} from "../../../core/store/shared/shared.actions";
import {SharedState} from "../../../core/store/shared/shared.state";

@Component({
  selector: 'app-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss']
})
export class DarkModeToggleComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;
  darkMode: boolean = false;

  constructor(private readonly store: Store) { }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.isDarkTheme$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.darkMode = value;
      });

    if(!localStorage.getItem('darkTheme')){
      localStorage.setItem('darkTheme', (this.darkMode).toString());
    }
    this.store.dispatch(
      new ToggleAppTheme(localStorage.getItem('darkTheme') === 'true')
    );

  }
  onToggle(): void {
    localStorage.setItem('darkTheme', (!this.darkMode).toString());
    this.store.dispatch(new ToggleAppTheme(!this.darkMode));
  }
}
